var map = {
	"./dioroom/dioroomIcon.png": 9830,
	"./dioroom/screenshots/d1.png": 3353,
	"./dioroom/screenshots/d2.png": 2994,
	"./dioroom/screenshots/d3.png": 6651,
	"./dioroom/screenshots/d4.png": 1012,
	"./dioroom/screenshots/d5.png": 2141,
	"./dioroom/screenshots/d6.png": 8374,
	"./dioroom/screenshots/d7.png": 3471,
	"./renegado/renegadoIcon.png": 94,
	"./renegado/screenshots/r1.png": 7843,
	"./renegado/screenshots/r2.png": 984,
	"./renegado/screenshots/r3.png": 4849,
	"./renegado/screenshots/r4.png": 1758,
	"./renegado/screenshots/r5.png": 599,
	"./renegado/screenshots/r6.png": 1596,
	"./renegado/screenshots/r7.png": 3861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6628;